<template>
  <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="驳回原因" v-if="status == 1">
<!--        <label style="color: #409EFF"></label>-->
        <el-input v-model="form.rejectReason" clearable></el-input>
      </el-form-item>
      <el-form-item label="驳回原因" v-if="status == 2">
<!--        <label style="color: #409EFF"></label>-->
        <el-input v-model="form.rejectReason" clearable readonly></el-input>
      </el-form-item>
    </el-form>
    <div class="flex-middle flex-center">
      <el-button plain @click="resetForm" v-show="status == 1">重置</el-button>
      <el-button plain @click="dialogVisible = false;$emit('fetchData')">取消</el-button>
      <el-button type="primary" @click="submit" v-show="status == 1">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Utils from "../../../assets/js/Utils";

export default {
  name: "RejectReasonDialog",
  data(){
    return{
      dialogVisible : false,
      form:{
        id:null,
        rejectReason:''
      },
      status: null,//1-填写驳回原因 2-查看驳回原因
    }
  },
  methods:{
    //保存
    submit(){
        axios.post(Urls.URL.data_url+'/'+this.form.id+'/reject',{rejectReason:this.form.rejectReason}).then(res => {
          this.dialogVisible = false
          this.$emit('fetchData')
        }).catch(err => {
            this.$alert(err.response.data.errorMessage || Utils.errorText)
        })
    },
    //重置数据
    resetForm() {
      this.form = Object.assign({})
      this.form.items = []
      this.form.id = this.dataId
    },
    // 显示弹出层
    async setMaskVisible(val, data , status,rejectReason) {
      // await this.fetchData()
      // this.allowAction = Utils.checkMenuOprate('enroll.data')
      this.dialogVisible = val
      this.status = status
      this.form.id = data
      if(this.status ===2){
        this.form.rejectReason = JSON.parse(rejectReason).rejectReason
      }else{
        this.form.rejectReason = ''
      }
      // this.form.rejectReason = JSON.stringify(rejectReason)
      // 暴力深拷贝
      // let _obj = JSON.stringify(data);
      // this.form = JSON.parse(_obj);
      // 当对象中只有一级属性，没有二级属性的时候，此方法为深拷贝，但是对象中有对象的时候，此方法，在二级属性以后就是浅拷贝
      // this.form  = Object.assign({},data)
      // if(!this.form.id) {
      //   this.form.items = []
      // }
      // this.dataId = this.form.id
      // this.form  = Object.assign({},this.form)
    },
  }
}
</script>

<style scoped>

</style>